export default __webpack_public_path__ + "static/media/desconciliar.ba9b2dcc.svg";